exports = module.exports = require("../../../../../node_modules/_css-loader@1.0.1@css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".contain[data-v-450dafde] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.contain .left[data-v-450dafde] {\n  -webkit-box-flex: 1;\n      -ms-flex: 1;\n          flex: 1;\n}\n.contain .right[data-v-450dafde] {\n  width: 500px;\n  margin-left: 20px;\n}\n.form-tip[data-v-450dafde] {\n  font-size: 12px;\n  color: red;\n  line-height: 1.5;\n}\n.preview-img-container[data-v-450dafde] {\n  width: 300px;\n}\n.preview-img-container .preview-img[data-v-450dafde] {\n  width: 100%;\n}", ""]);

// exports
